import { LINE_ITEM_GIFT_CARD_DEDUCTION_1, LINE_ITEM_GIFT_CARD_DEDUCTION_2, LINE_ITEM_GIFT_CARD_DEDUCTION_3, } from '../../utils/lineItemTypes';
const getGiftCardLineItems = (lineItems) => {
    return lineItems.filter(lineItem => lineItem.code === LINE_ITEM_GIFT_CARD_DEDUCTION_1 ||
        lineItem.code === LINE_ITEM_GIFT_CARD_DEDUCTION_2 ||
        lineItem.code === LINE_ITEM_GIFT_CARD_DEDUCTION_3);
};
export default getGiftCardLineItems;
